import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Checkout = () => {
  const intialState = {
    first_name: "",
    last_name: "",
    address: "",
    pincode: "",
    country: "",
  };
  const [address, setAddress] = useState(intialState);
  const storedCart = JSON.parse(localStorage.getItem("cart")) || [];
  const user_data = JSON.parse(localStorage.getItem("user_data")) || [];
  const handleChange = ({ target }) => {
    const name = target && target.name;
    const value = target && target.value;
    setAddress({ ...address, [name]: value });
  };
  const handleShippingAddress = async (e) => {
    e.preventDefault();
    const response = await axios.post(
      `https://sachiproduct-backend.theaditech.in/api/user/update/${user_data.id}`,
      {
        shipping_address: [
          {
            first_name: address.first_name,
            last_name: address.last_name,
            address: address.address,
            pincode: address.pincode,
            country: address.country,
          },
        ],
      },
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    if (response) {
      toast.success("address update success");
      setAddress(intialState);
    } else {
      toast.error("Server error");
    }
  };
  const handleLogout =() =>{
    localStorage.clear();
  }
  return (
    <main className="main-content">
      {/* <!--== Start Product Area Wrapper ==--> */}
      <section className="product-area product-information-area">
        <div className="container">
          <div className="product-information">
            <div className="row">
              <div className="col-lg-7">
                <div className="edit-checkout-head">
                  {/* <div className="header-logo-area">
                  <Link to="index.html">
                    <img className="logo-main" src="assets/img/logo.png" alt="Logo"/>
                    <img className="logo-light" src="assets/img/logo.png" alt="Logo"/>
                  </Link>
                </div> */}
                  {/* <div className="breadcrumb-area">
                  <ul>
                    <li><Link to="shop-cart.html">Cart</Link><i className="fa fa-angle-right"></i></li>
                    <li className="active">Information<i className="fa fa-angle-right"></i></li>
                    <li>Shipping<i className="fa fa-angle-right"></i></li>
                    <li>Payment</li>
                  </ul>
                </div> */}
                </div>
                <div className="edit-checkout-information">
                  <h4 className="title">Contact information</h4>
                  <div className="logged-in-information">
                    <div
                      className="thumb"
                      data-bg-img="assets/img/photos/gravatar2.png"
                    ></div>
                    <p>
                      <span className="name">
                        {user_data?.name ? user_data.name : "Guest"}
                      </span>
                      <span>
                        ({user_data?.email ? user_data.email : "No email"})
                      </span>
                      <Link to="#" onClick={handleLogout}>Log out</Link>
                    </p>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="inlineCheckbox1"
                      value="option1"
                    />
                    <label className="form-check-label" for="inlineCheckbox1">
                      Keep me up to date on news and exclusive offers
                    </label>
                  </div>
                  <div className="edit-checkout-form">
                    <h4 className="title">Shipping address</h4>
                    <div className="row row-gutter-12">
                      <div className="col-lg-6">
                        <div className="form-floating">
                          <input
                            type="text"
                            className="form-control"
                            id="first_name"
                            name="first_name"
                            placeholder="name"
                            value={address.first_name}
                            onChange={handleChange}
                          />
                          <label for="floatingInputGrid">
                            First name (optional)
                          </label>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-floating">
                          <input
                            type="text"
                            className="form-control"
                            id="floatingInput2Grid"
                            placeholder="name"
                            name="last_name"
                            value={address.last_name}
                            onChange={handleChange}
                          />
                          <label for="floatingInput2Grid">Last name</label>
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="form-floating">
                          <input
                            type="text"
                            className="form-control"
                            id="floatingInput3Grid"
                            name="address"
                            placeholder="address"
                            value={address.address}
                            onChange={handleChange}
                          />
                          <label for="floatingInput3Grid">Address</label>
                        </div>
                      </div>
                      {/* <div className="col-lg-12">
                        <div className="form-floating">
                          <input
                            type="text"
                            className="form-control"
                            id="floatingInput4Grid"
                            placeholder="address"
                            value=""
                            onChange={handleChange}
                          />
                          <label for="floatingInput4Grid">
                            Apartment, suite, etc. (optional)
                          </label>
                        </div>
                      </div> */}
                      {/* <div className="col-lg-12">
                        <div className="form-floating">
                          <input
                            type="text"
                            className="form-control"
                            id="floatingInput5Grid"
                            placeholder="address"
                            value=""
                            onChange={handleChange}
                          />
                          <label for="floatingInput5Grid">
                            Apartment, suite, etc. (optional)
                          </label>
                        </div>
                      </div> */}
                      <div className="col-lg-6">
                        <div className="form-floating">
                          <select
                            className="form-select form-control"
                            id="floatingInput6rid"
                            name="country"
                            aria-label="Floating label select example"
                            value={address.country}
                            onChange={handleChange}
                          >
                            <option selected>Bangladesh</option>
                            <option value="1">Afghanistan</option>
                            <option value="2">Åland Islands</option>
                            <option value="3">Albania</option>
                          </select>
                          <div className="field-caret"></div>
                          <label for="floatingInput6rid">Country/Region</label>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-floating">
                          <input
                            type="text"
                            className="form-control"
                            id="floatingInput7Grid"
                            placeholder="address"
                            name="pincode"
                            value={address.pincode}
                            onChange={handleChange}
                          />
                          <label for="floatingInput7Grid">Postal code</label>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="btn-box">
                          <Link className="btn-return" to="/cart">
                            <svg
                              focusable="false"
                              aria-hidden="true"
                              className="icon-svg icon-svg--color-accent icon-svg--size-10 previous-link__icon"
                              role="img"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 10 10"
                            >
                              <path d="M8 1L7 0 3 4 2 5l1 1 4 4 1-1-4-4"></path>
                            </svg>
                            Return to cart
                          </Link>
                          <button
                            className="btn-shipping"
                            onClick={(e) => handleShippingAddress(e)}
                          >
                            Continue to shipping
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="shipping-cart-subtotal-wrapper">
                  <div className="shipping-cart-subtotal">
                    {storedCart.map((element) => {
                      return (
                        <div className="shipping-cart-item">
                          <div className="thumb">
                            <img
                              src={`https://sachiproduct-backend.theaditech.in/${element.image}`}
                              alt=""
                            />
                            <span className="quantity">1</span>
                          </div>
                          <div className="content">
                            <h4 className="title">2.{element.name}</h4>
                            <span className="info">m / gold</span>
                            <span className="price">$100.00</span>
                          </div>
                        </div>
                      );
                    })}
                    {/* <div className="shipping-cart-item">
                      <div className="thumb">
                        <img src="assets/img/shop/cart/mini2.webp" alt="" />
                        <span className="quantity">1</span>
                      </div>
                      <div className="content">
                        <h4 className="title">11. Product with video</h4>
                        <span className="info">purple</span>
                        <span className="price">$39.00</span>
                      </div>
                    </div> */}
                    <div className="shipping-subtotal">
                      <p>
                        <span>Subtotal</span>
                        <span>
                          <strong>$200</strong>
                        </span>
                      </p>
                      <p>
                        <span>Shipping</span>
                        <span>Calculated at next step</span>
                      </p>
                    </div>
                    <div className="shipping-total">
                      <p className="total">Total</p>
                      <p className="price">
                        <span className="usd">USD</span>$200.00
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!--== End Product Area Wrapper ==--> */}
      <div className="edit-checkout-footer">
        <p>All rights reserved Demo Alan</p>
      </div>
    </main>
  );
};
export default Checkout;
